import { types } from 'mobx-state-tree'

export const Jurisdiction = types.model('JurisdictionModel', {
  id: types.identifierNumber,
  name: types.string,
  alpha2: types.string,
  alpha3: types.string,
  logo: types.string,
  countryCode: types.maybeNull(types.string),
  description: types.maybeNull(types.string),
  descriptionParser: types.maybeNull(types.string),
  iso_3166_2: types.maybeNull(types.string),
})
